import { Attr, BelongsTo, Model } from "spraypaint";

import type { FeatureId } from "shared/helpers/features";
import { ApplicationRecord } from "shared/services/spraypaint";

import type FeatureTeaser from "./FeatureTeaser";
import type InstantInsightsReport from "./InstantInsightsReport";
import type MediaRequest from "./MediaRequest";
import type TranscriptRequest from "./TranscriptRequest";
import type User from "./User";

@Model()
class ViewedItem extends ApplicationRecord {
  static jsonapiType = "viewed_items";

  @Attr() feature: FeatureId;

  @BelongsTo() target:
    | MediaRequest
    | TranscriptRequest
    | FeatureTeaser
    | InstantInsightsReport;

  @Attr() targetId: number;

  @Attr() targetType: string;

  @BelongsTo() user: User;

  @Attr() userId: number;

  @Attr() viewedAt: string;
}

export default ViewedItem;
